import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import tippy from 'tippy.js';
import 'long-press-event';

export default class DashboardBoxComponent extends Component {
  @tracked isOpen = false;
  tippyInstance = null;

  get getQueryParams() {
    return this.args.query ?? {};
  }

  get isRow() {
    return this.args.variant === 'row';
  }

  @action
  deleteBookmark() {
    this.args.bookmark?.destroyRecord();
  }

  @action
  editBookmark() {
    this.args?.editBookmark?.(this.args.bookmark);
  }

  @action
  initiateBookmarkBox(element) {
    if (this.isRow) return;
    this.createTippy(element);
    this.attachLongPressEventListener(element);
  }

  @action
  attachLongPressEventListener(element) {
    element.addEventListener('long-press', (e) => {
      e.preventDefault();
      this.tippyInstance.show();
    });
  }

  @action
  createTippy(element) {
    if (!this.args.bookmark) return;
    let trigger = element.querySelector('.bookmark-tippy-trigger');
    let dropdown = element.querySelector('.bookmark-tippy-dropdown');
    this.tippyInstance = tippy(trigger, {
      content: dropdown,
      arrow: false,
      trigger: 'click',
      interactive: true,
      appendTo: element,
    });
  }

  @action
  closeMenu() {
    this.tippyInstance.hide();
  }

  @action
  goToUrl() {
    return window.open(this.args.url, '_blank');
  }
}
